package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class SingleSelectionContent @OptIn(ExperimentalUuidApi::class) constructor(
    val text: QuizText,
    val detail: String,
    val options: List<Option>,
    val info: QuizText? = null,
    override val id: String = Uuid.random().toHexDashString()
) : IQuizContent, ICountableQuiz {
    // Helper constructors for StringResource and String text
    constructor(text: StringResource, detail: String, options: List<Option>) :
        this(QuizText.Resource(text), detail, options, null)
    constructor(text: String, detail: String, options: List<Option>, info: String? = null) :
        this(QuizText.Plain(text), detail, options, info?.let { QuizText.Plain(it) })
    // Constructor with textArgs for StringResource with placeholders
    constructor(text: StringResource, textArgs: List<Any>, detail: String, options: List<Option>) :
        this(QuizText.Resource(text, textArgs), detail, options, null)
    // Constructors with QuizText info
    constructor(text: StringResource, detail: String, options: List<Option>, info: QuizText) :
        this(QuizText.Resource(text), detail, options, info)
    constructor(text: StringResource, textArgs: List<Any>, detail: String, options: List<Option>, info: QuizText) :
        this(QuizText.Resource(text, textArgs), detail, options, info)
}

